var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14660_10461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 7.71358C10.7858 7.71358 11.4226 7.07683 11.4226 6.29136C11.4226 5.50589 10.7858 4.86914 10.0003 4.86914C9.21488 4.86914 8.57812 5.50589 8.57812 6.29136C8.57812 7.07683 9.21488 7.71358 10.0003 7.71358Z",
    fill: "#FF0F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.44434V14.0203",
    stroke: "#FF0F00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 18.9587C14.9489 18.9587 18.9596 14.9479 18.9596 10.0003C18.9596 5.05277 14.9489 1.04199 10.0013 1.04199C5.05375 1.04199 1.04297 5.05277 1.04297 10.0003C1.04297 14.9479 5.05375 18.9587 10.0013 18.9587Z",
    stroke: "#FF0F00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14660_10461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedInfoIcon);
export default __webpack_public_path__ + "static/media/redInfoIcon.89aa2ee7772338b0dd3d278094ba3eeb.svg";
export { ForwardRef as ReactComponent };